import styled, { css } from 'styled-components';

export const ChartContainer = styled.div`
  border: 1px solid var(--mid-gray-chart);
  margin: 20px 0;
  padding: 24px;
`;

export const ChartTitle = styled.h1`
  font-size: 18px;
  line-height: 18px;
  font-weight: bold;
  color: var(--luft-primary);
`;

export const LegendContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

export const DataKeyContainer = styled.div`
  background-color: ${({ backgroundColor }) =>
    backgroundColor && backgroundColor};
  color: var(--mid-gray-rechart);
  font-weight: bold;
  font-size: 10px;
  line-height: 14px;
  padding: 4px 9px;
  border-radius: 4px;
  text-transform: capitalize;
  font-style: italic;
  width: 76px;
  text-align: center;
`;

export const ChartHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  h1 {
    flex: 1;
  }

  button {
    margin-left: 8px;
    border-radius: 4px;

    &:hover {
      opacity: 0.8;
    }
  }
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
`;

export const Col = styled.div`
  ${({ md12 }) =>
    md12 &&
    css`
      @media (min-width: 768px) {
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
      }
    `}
`;
